import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';
import CopyTextIcon from '../../../../assets/icons/copy-text.svg';

import EditorJsDataToTextParser from '../../../../services/editorJS/EditorJsDataToTextParser';
import {
  parseJsonToEditorState,
  parseReadOnly,
} from '../../../../services/editorJS/utils';
import { Action } from '../../../../components/index';
import { notify } from '../../../../store/modules/notifications/actions';
import { selectProject } from '../../../../store/modules/projects/selectors';

type Props = {
  script: string;
};

const CopyScriptTextAction = ({ script }: Props) => {
  const dispatch = useDispatch();
  const currentProject = useSelector(selectProject);

  const onClick = useCallback(() => {
    let text = '';
    let isError = false;
    try {
      const editorJsData = parseReadOnly(parseJsonToEditorState(script));
      const editorParser = new EditorJsDataToTextParser(editorJsData, { project: currentProject.data });
      text = editorParser.parse();
      if (!text) {
        // empty text for ios
        text = ' ';
      }
    } catch (e) {
      isError = true;
      console.log(e);
    }

    if (!isError && copyToClipboard(text, { format: 'text/plain' })) {
      dispatch(
        notify({
          type: 'success',
          icon: 'copy',
          message: 'Script text copied.',
        }),
      );
    } else {
      dispatch(
        notify({
          type: 'error',
          icon: 'copy',
          message: 'Script text copying failed.',
        }),
      );
    }
  }, [dispatch, script, currentProject]);

  return (
    <Action
      title="Copy text"
      icon={<img src={CopyTextIcon} alt="copy text icon" width="14px" />}
      onClick={onClick}
    />
  );
};

export default CopyScriptTextAction;
